import { createApp } from 'vue';
import ImageGallery from './ImageGallery.vue';
import store from 'shared/store';
import './ImageGallery.scss';

function mountImageGallery() {
	const imageGallery = document.querySelectorAll('[data-image-gallery]');

	if (imageGallery?.length) {
		imageGallery.forEach(elem => {
			const app = createApp({
				name: 'ImageGalleryApp',
			});
			app.use(store);
			app.component('image-gallery', ImageGallery);
			app.mount(elem);
		});
	}
}

mountImageGallery();
